import React from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './components/Header/Header';
import Contents from './components/Contents/Contents';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Contents></Contents>
    </div>
  );
}

export default App;
